export default function ISTP(props) {
  return (
    <div className="row">
      <div className="col-12 p-5">
        <article className="main description">
          <h1>شخصیت “چیره&zwnj;دست”</h1>{" "}
          <blockquote>
            <p>
              می&zwnj;خواستم زندگی کنم، یک زندگی متفاوت. نمی&zwnj;خواستم هر روز
              به همان محل قبلی بروم، همان آدمهای قبلی را ببینم و همان کارهای
              قبلی را انجام بدهم. می&zwnj;خواستم چالش&zwnj;های جالبی داشته باشم.
            </p>{" "}
            <footer>Harrison Ford</footer>
          </blockquote>{" "}
          <p>
            چیره&zwnj;دستان عاشق اکتشاف با دست و چشم خود، لمس کردن و بررسی کردن
            جهان اطراف با عقل محض و روحیه کنجکاوی هستند. افراد دارای این نوع
            شخصیت سازندگانی بالفطره هستند، در حال رفتن از یک پروژه به سراغ پروژه
            بعدی، ساختن چیزهای مفید و بیهوده برای لذت بردن از آن، و آموختن از
            محیط خود هستند. شخصیت&zwnj;های چیره&zwnj;دست اغلب مکانیک و مهندس
            هستند که هیچ چیزی برایشان شادی&zwnj;آورتر از کثیف کردن دستها و جدا
            کردن اجزا و سر هم کردن دوباره آنها نیست، به&zwnj;طوری که کمی از قبل
            بهتر باشد.
          </p>{" "}
          <p>
            چیره&zwnj;دستان به کنکاش در ایده&zwnj;ها از طریق ایجاد،
            عیب&zwnj;یابی، آزمون و خطا و تجربه دست اول می&zwnj;پردازند. این
            شخصیت&zwnj;ها از اینکه دیگران به پروژه&zwnj;های آنها علاقه نشان
            بدهند لذت می&zwnj;برند و گاهی اوقات حتی اهمیتی نمی&zwnj;دهند که این
            افراد وارد حریم خصوصی&zwnj;شان شده&zwnj;اند. البته، این به شرطی است
            که چنان افرادی در اصول و آزادی چیره&zwnj;دستان اختلالی پدید نیاورند
            و باید صادقانه با چیره&zwnj;دستان در مورد علاقه خود صحبت کنند.
          </p>{" "}
          <p>
            افراد دارای شخصیت چیره&zwnj;دست اغلب از کمک کردن و به اشتراک گذاشتن
            تجربه خود، به&zwnj;خصوص با کسانی که به آنها اهمیت می&zwnj;دهند لذت
            می&zwnj;برند و چقدر بد که تعدادشان بسیار اندک است و تنها حدود پنج
            درصد از جمعیت را تشکیل می&zwnj;دهند. به&zwnj;طور خاص زنان
            چیره&zwnj;دست نادر هستند و نقش&zwnj;های جنسیتی که معمولاً جامعه
            انتظار دارد چندان متناسب آنها نیست - آن&zwnj;ها اغلب در سنین جوانی
            خود را به شکل پسران درمی&zwnj;آورند.
          </p>{" "}
          <h2>جرأت متفاوت بودن</h2>{" "}
          <p>
            در حالی که طبیعت کم&zwnj;حرف و تمرکز چیره&zwnj;دستان بر مسائل عملی
            باعث می&zwnj;شود این شخصیت&zwnj;ها در نگاه اول ساده به نظر برسند،
            اما آنها در واقع افرادی کاملاً پیچیده&zwnj;اند. شخصیت
            چیره&zwnj;دستان دوستانه اما بسیار خصوصی، آرام اما به&zwnj;طور
            ناگهانی خودانگیخته، بسیار کنجکاو، اما قادر به متمرکز ماندن بر
            تحصیلات رسمی است و پیش&zwnj;بینی آنها حتی توسط دوستان و عزیزانشان
            چالش برانگیز است. چیره&zwnj;دستان ممکن است برای مدتی بسیار وفادار و
            ثابت&zwnj;قدم به نظر برسند، اما معمولاً انرژی فراوانی در خود نگه
            می&zwnj;دارند که بدون هشدار منفجر می&zwnj;شود و علایق آنها را به
            مسیرهای جسورانه تازه&zwnj;ای هدایت می&zwnj;کند.
          </p>{" "}
          <blockquote className="no-footer">
            <p>
              هرچند چیره&zwnj;دستان در هنگام بروز چنین تغییرات شدیدی به&zwnj;جای
              امتحان کردن چشم&zwnj;اندازی تازه، صرفاً به بررسی دوام این علایق
              می&zwnj;پردازند.
            </p>
          </blockquote>{" "}
          <p>
            تصمیمات چیره&zwnj;دستان از حس واقع گرایی عملی آنها ناشی می&zwnj;شود
            و در قلبشان حس نیرومند انصاف وجود دارد، نگرش "چیزی را که دوست نداری
            در مورد دیگران انجام مده"، واقعاً کمک می&zwnj;کند بتوان بسیاری از
            صفات گیج&zwnj;کننده چیره&zwnj;دستان را توضیح داد. افراد دارای شخصیت
            چیره&zwnj;دست بجای احتیاط بیش از حد و اجتناب از وارد کردن درد و رنج
            به دیگران به احتمال زیاد پا را بسیار فراتر می&zwnj;گذارند و
            تلافی&zwnj;جویی متقابل را هم چه خوب و چه بد می&zwnj;پذیرند زیرا آن
            را بخشی از بازی منصفانه می&zwnj;دانند.
          </p>{" "}
          <p>
            بزرگ&zwnj;ترین مسئله&zwnj;ای که شخصیت&zwnj;های چیره&zwnj;دست به
            احتمال زیاد با آن مواجه می&zwnj;شوند این است که خیلی زود دست به عمل
            می&zwnj;زنند، آزادی خود را مفروض می&zwnj;گیرند و فرض می&zwnj;کنند که
            دیگران هم همین&zwnj;طور هستند. آن&zwnj;ها اولین کسانی هستند که
            می&zwnj;توان جوک&zwnj;های حساس را برایشان تعریف کرد، به
            پروژه&zwnj;های دیگران بیش از حد علاقه&zwnj;مند می&zwnj;شوند، مزاحمت
            و سر و صدا ایجاد می&zwnj;کنند، یا به&zwnj;طور ناگهانی برنامه خود را
            تغییر می&zwnj;دهند چون با چیزی جالب&zwnj;تری مواجه شده&zwnj;اند.
          </p>{" "}
          <h2>
            هیچ چیز به اندازه اینکه همه با تو موافق باشند کسل&zwnj;کننده نیست
          </h2>{" "}
          <p>
            چیره&zwnj;دستان این نکته را خواهند آموخت که بسیاری از انواع شخصیتی
            دیگر خطوط قرمز محکمتری در مورد قوانین و رفتارهای قابل قبول دارند -
            شخصیت&zwnj;های حساس&zwnj;تر اغلب دوست ندارند جوک&zwnj;های حساس
            بشنوند، و قطعاً در جواب جوکی مشابه نمی&zwnj;گویند، و نمی&zwnj;خواهند
            رفتار پر سر و صدا، حتی در حین مهمانی داشته باشند. اگر وضعیت عاطفی از
            قبل مشکل&zwnj;آفرین شده باشد، نادیده گرفتن این مرزها می&zwnj;تواند
            نتیجه&zwnj;ای کاملاً معکوس داشته باشد.
          </p>{" "}
          <p>
            چیره&zwnj;دستان مشکل خاصی در پیش&zwnj;بینی احساسات دارند اما این امر
            تنها ناشی از انصاف درونی آنهاست، چرا که ارزیابی احساسات و
            انگیزه&zwnj;های چیره&zwnj;دستان بسیار دشوار است. با این حال، تمایل
            آنها به کاوش در روابط خود از طریق اقدامات و نه از طریق همدلی
            می&zwnj;تواند به شرایط بسیار دشواری منجر شود. افراد دارای شخصیتی
            چیره&zwnj;دست مرزها و دستورالعملها را کنار می&zwnj;گذارند و ترجیح
            می&zwnj;دهند آزادی داشته باشند و اگر لازم بود خارج از خطوط را هم رنگ
            کنند.
          </p>{" "}
          <p>
            پیدا کردن محیطی که بتوانند با دوستان خوبشان همکاری کنند، کسانی که
            سبک و غیرقابل پیش&zwnj;بینی بودن آنها را درک نمایند، استفاده از
            خلاقیت، حس شوخ&zwnj;طبعی و رویکرد عملی خود برای ایجاد
            راه&zwnj;حل&zwnj;های عملی به شخصیت&zwnj;های چیره&zwnj;دست فرصت
            می&zwnj;دهد سال&zwnj;های سال با شادمانی به ساخت جعبه&zwnj;های مفیدی
            بپردازند - و آنها از بیرون تحسین کنند.
          </p>
        </article>
      </div>
    </div>
  );
}
